export default "__VITE_ASSET__CDMrMlTy__"